import React from 'react';

function Footer() {
  return (
    <footer className="footer">
      <div className="container">
        <p>&copy; 2024 Morning Light Funeral Services. All rights reserved.</p>
        <p>Serving families with compassion and dignity</p>
      </div>
    </footer>
  );
}

export default Footer;
